module.exports = __webpack_public_path__ + "static/media/YM28_0.1af13da1.jpg";